import React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "../../data/content";
import PageMeta from "./PageMeta";

const NotFound = () => {
  return (
    <section className={"not-found"}>
      <PageMeta
        title={"Page not found"}
        noIndex
      />
      <h1 className={"section-title"}>Page not found</h1>
      <span className={"title-rule"} />
      <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
      <Link
        to={ROUTES.HOME}
        className={"btn"}
      >
        Back to home
      </Link>
    </section>
  );
};

export default NotFound;
